import { FiscalFileLocationDto } from '@cradua/data';
import { Component, OnInit } from '@angular/core';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-file-location-container',
  templateUrl: './file-location-container.component.html',
  styleUrls: ['./file-location-container.component.scss'],
})
export class FileLocationContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  filelocations$: Observable<FiscalFileLocationDto[]>;
  loading: boolean;
  isLoadingFileLocation$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingFileLocation$ = this.gatwayFacade.isLoadingGateway(
      'FiscalFileLocation'
    );
    this.filelocations$ = this.gatwayFacade.loadGateway('FiscalFileLocation');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteFileLocation(deletedValue: any) {
    this.gatwayFacade.remove('FiscalFileLocation', deletedValue);
  }

  // this method control both the create and update

  onSubmitFileLocation(formValue: any) {
    // event.preventDefault();
    // console.log(formValue);
    const pullData = formValue.FileLocations;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllFiscalFileLocation = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData?.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllFiscalFileLocation.push(pullData[i]);
      }
    }

    // check if the addAllFiscalFileLocation array is not empty, then dispatch the data to the store
    if (addAllFiscalFileLocation.length > 0) {
      this.gatwayFacade.add('FiscalFileLocation', addAllFiscalFileLocation);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('FiscalFileLocation', allUpdates, ['id']);
    }
  }
}
